export default __webpack_public_path__ + "static/media/06.2a7106a7.webp";